export default function HeroBanner() {
  return (
    <section className="hero-banner d-flex align-items-center text-center">
      <div className="container">
        <h1 className="hero-title">Build Your Website in Minutes</h1>
        <p className="hero-subtext">
          Just fill one form — Casual Tech handles everything.
        </p>

        <a className="btn btn-primary btn-lg mt-3" href="/start">
          Just Fill One Form — Get Your Website
        </a>
      </div>
    </section>
  );
}